<template>
  <div
    class="flex flex-no-wrap lg:flex-wrap self-stretch lg:self-auto mb-3 lg:mb-8"
  >
    <div class="max-w-full w-full">
      <div v-swiper:swiperTop="swiperOptionTop" class="swiper gallery-top">
        <div class="swiper-wrapper">
          <div
            v-for="(image, index) in images"
            :key="index"
            class="swiper-slide"
            :class="`slide-${index + 1}`"
          >
            <img
              :src="image"
              class="max-w-full"
              @click="$refs.lightbox.show(index)"
            />
          </div>
        </div>
      </div>

      <div
        v-swiper:swiperThumbs="swiperOptionThumbs"
        class="swiper gallery-thumbs"
      >
        <div class="swiper-wrapper">
          <div
            v-for="(image, index) in images"
            :key="index"
            class="swiper-slide"
            :class="`slide-${index + 1}`"
          >
            <img :src="image" class="w-full h-full object-fit-cover" />
          </div>
        </div>
        <div slot="button-next" class="swiper-btn-next swiper-btn" />
        <div slot="btn-prev" class="swiper-btn-prev swiper-btn" />
      </div>
    </div>

    <Lightbox ref="lightbox" :images="images" />
  </div>
</template>

<script>
import Lightbox from '~/components/Lightbox'

export default {
  components: {
    Lightbox,
  },

  props: {
    images: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      swiperOptionTop: {
        spaceBetween: 10,
        loop: true,
        loopedSlides: 5, // looped slides should be the same
      },
      swiperOptionThumbs: {
        spaceBetween: 10,
        slidesPerView: 4.5,
        touchRatio: 0.2,
        loop: true,
        loopedSlides: 5, // looped slides should be the same
        slideToClickedSlide: true,
        navigation: {
          nextEl: '.swiper-btn-next',
          prevEl: '.swiper-btn-prev',
        },
      },
    }
  },

  mounted() {
    this.$nextTick(() => {
      const swiperTop = this.swiperTop
      const swiperThumbs = this.swiperThumbs
      swiperTop.controller.control = swiperThumbs
      swiperThumbs.controller.control = swiperTop
    })
  },
}
</script>

<style lang="scss" scoped>
.gallery-top {
  height: 0px;
  padding-top: 56.25%;
  margin-bottom: 10px;

  @apply rounded-sm;
}

.gallery-thumbs {
  height: 0px;
  padding-top: 15.3645833%;

  @apply rounded-sm;
}

.swiper-wrapper {
  @apply absolute pin-t;
}

.swiper-slide {
  @apply rounded-sm overflow-hidden;
}

.swiper-btn {
  top: 50%;
  width: 60px;
  height: 60px;
  margin-top: -30px;

  @apply absolute z-10 rounded-sm bg-black bg-center bg-no-repeat;

  &:hover {
    @apply bg-blue-darkest;
  }
}

.swiper-btn-next {
  right: 0;
  background-image: url("data:image/svg+xml,%3Csvg width='9' height='16' viewBox='0 0 9 16' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.95 8.003L.476 2.528a.794.794 0 0 1-.234-.566c0-.214.083-.415.234-.566l.48-.48a.794.794 0 0 1 .566-.233c.214 0 .415.083.566.234l6.518 6.518a.794.794 0 0 1 .233.568.794.794 0 0 1-.233.568l-6.512 6.512a.794.794 0 0 1-.566.234.794.794 0 0 1-.567-.234l-.48-.48a.801.801 0 0 1 0-1.131l5.47-5.469z' fill='%23FFF' fill-rule='nonzero'/%3E%3C/svg%3E");
  box-shadow: 20px 0px 50px 40px rgb(255, 255, 255);
}

.swiper-btn-prev {
  left: 0;
  background-image: url("data:image/svg+xml,%3Csvg width='10' height='15' viewBox='0 0 10 15' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3.757 7.363l5.475 5.475c.15.15.233.351.233.565a.794.794 0 0 1-.233.567l-.48.479a.794.794 0 0 1-.566.234.794.794 0 0 1-.566-.234L1.1 7.931a.794.794 0 0 1-.233-.568c0-.215.082-.417.233-.568L7.614.283A.794.794 0 0 1 8.18.049c.214 0 .415.083.566.234l.48.48a.801.801 0 0 1 0 1.131l-5.47 5.469z' fill='%23FFF' fill-rule='nonzero'/%3E%3C/svg%3E");
  box-shadow: -20px 0px 50px 40px rgb(255, 255, 255);
}

.swiper {
  @apply hidden;

  &.swiper-container-initialized {
    @apply block;
  }
}
</style>
